import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as s } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import d from "../../../../../core/Context/useCoreContext.js";
import o from "../../../../internal/Typography/Typography.js";
import { TypographyElement as m, TypographyVariant as c } from "../../../../internal/Typography/types.js";
import { AccountDetails as A } from "../AccountDetails/AccountDetails.js";
import { GrantAdjustmentDetails as f } from "../GrantAdjustmentDetails/GrantAdjustmentDetails.js";
/* empty css                           */
import h from "../../../../internal/InfoBox/InfoBox.js";
import { Translation as N } from "../../../../internal/Translation/Translation.js";
const t = "adyen-pe-grant-repayment-details", i = {
  balanceInfo: `${t}__balance-info`,
  repaymentInfo: `${t}__repayment-info`,
  repaymentAccount: `${t}__repayment-account`,
  repaymentNotice: `${t}__repayment-notice`
}, C = ({ grant: n, onDetailsClose: p }) => {
  const { i18n: a } = d(), l = s(() => {
    var r;
    return (r = n.unscheduledRepaymentAccounts) == null ? void 0 : r[0];
  }, [n.unscheduledRepaymentAccounts]), u = s(() => {
    const { currency: r, value: y } = n.remainingTotalAmount;
    return a.amount(y, r);
  }, [a, n.remainingTotalAmount]);
  return l ? /* @__PURE__ */ e(
    f,
    {
      className: t,
      onDetailsClose: p,
      headerTitleKey: "capital.sendRepayment",
      headerSubtitleKey: "capital.sendRepaymentSubtitle",
      children: [
        /* @__PURE__ */ e("div", { className: i.repaymentInfo, children: [
          /* @__PURE__ */ e("section", { className: i.repaymentAccount, children: [
            /* @__PURE__ */ e(o, { el: m.SPAN, variant: c.BODY, stronger: !0, children: a.get("capital.bankAccountDetails") }),
            /* @__PURE__ */ e(A, { bankAccount: l })
          ] }),
          /* @__PURE__ */ e("section", { className: i.repaymentNotice, children: /* @__PURE__ */ e(o, { el: m.PARAGRAPH, variant: c.CAPTION, children: a.get("capital.sendRepaymentNotice") }) })
        ] }),
        /* @__PURE__ */ e(h, { className: i.balanceInfo, children: /* @__PURE__ */ e(o, { variant: c.BODY, children: /* @__PURE__ */ e(
          N,
          {
            translationKey: "capital.repaymentBalanceInfo",
            fills: {
              amount: /* @__PURE__ */ e(o, { el: m.SPAN, variant: c.BODY, strongest: !0, children: u })
            }
          }
        ) }) })
      ]
    }
  ) : null;
};
export {
  C as GrantRepaymentDetails
};
